import { CreditCard } from '@alinta-digital/payment-form/components';
import { PaymentCardType } from '@alinta-digital/payment-form/types';
import { CustomCheckout } from '@alinta-digital/payment-form/view/PaymentDetails/PaymentDetails.types';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { config } from '../../config';
import { loadStripe } from '@stripe/stripe-js';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import StripeCards from '@alinta-digital/payment-form/components/Stripe';
import { StripePaymentMethod } from '@alinta-digital/payment-form/components/Stripe/StripeCreditCard/StripeCreditCard';

interface DirectDebitCreditCardProps {
  instance: CustomCheckout | null;
  loading: boolean;
  setIsCardValid: (isValid: boolean) => void;
  setPaymentMethod?: (paymentMethod: StripePaymentMethod) => void;
  isStripeEnabled?: boolean;
}

const DirectDebitCreditCard = ({
  instance,
  loading,
  setIsCardValid,
  setPaymentMethod,
  isStripeEnabled,
}: DirectDebitCreditCardProps) => {
  const { setFieldValue } = useFormikContext();
  const stripePromise = useMemo(() => loadStripe(config.stripeKey!), [
    config.stripeKey,
  ]);
  return (
    <>
      {isStripeEnabled && (
        <StripeCards
          isWeb={true}
          isUsedForDirectDebit={true}
          sectionKey="debitDetails"
          instance={instance}
          stripePromise={stripePromise}
          stripePkkey={config.stripeKey as string}
          onError={() => {
            setFieldValue('debitDetails.cardType', '', false);
            setIsCardValid(false);
          }}
          onComplete={(
            cardType: PaymentCardType,
            PaymentMethod?: StripePaymentMethod
          ) => {
            setFieldValue('debitDetails.cardType', cardType, false);
            PaymentMethod &&
              setPaymentMethod &&
              setPaymentMethod(PaymentMethod);
            setIsCardValid(true);
          }}
          disabled={false}
        />
      )}
      {!isStripeEnabled && (
        <CreditCard
          sectionKey="debitDetails"
          instance={instance}
          onError={() => {
            setFieldValue('debitDetails.cardType', '', false);
            setIsCardValid(false);
          }}
          onComplete={(cardType: PaymentCardType) => {
            setFieldValue('debitDetails.cardType', cardType, false);
            setIsCardValid(true);
          }}
          disabled={false}
        />
      )}
    </>
  );
};

export default DirectDebitCreditCard;
